module.exports = __webpack_public_path__ + "static/media/status_1.bd453ddd.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/collectionOnline/images/status_1.png
// module id = 621
// module chunks = 0